import { SproToasterService } from "../sproLib/spro/services/spro-toaster/spro-toaster.service";
import { HttpClient } from "@angular/common/http";
import { HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Observable } from "rxjs/Observable";

/**
 *  Service permettant de mettre en commun des fonctions utilisées dans toute l'application
 */
@Injectable()
export class AppSettingsService {
  /** Session en cours */
  public h_currentUser: any;

  /**
   * Constructeur
   */
  constructor(
    public http: HttpClient,
    public s_translate: TranslateService,
    public s_toaster: SproToasterService
  ) {}

  /**
   * Fonction de recuperation du lien vers l'API contenu dans le json assets/appsettings.json
   * Retour : json avec lien vers API (settings.pathAPI)
   */
  public proc_getSettings(): Observable<any> {
    return this.http.get("../../assets/appsettings.json");
  }

  /**
   * Fonction de selection de la langue a utiliser par défaut dans l'application
   */
  public proc_initLangue() {
    this.s_translate.addLangs(["de", "de-AT", "en", "fr", "hu", "it", "pt"]);
    this.s_translate.setDefaultLang("en");
    const w_browserLang = this.s_translate.getBrowserLang();
    this.s_translate.use(
      w_browserLang.match(/de|de-AT|en|fr|hu|it|pt/) ? w_browserLang : "en"
    );
  }

  /**
   * Fonction de configuration des headers des requetes HTTP
   * Retour : headers a utiliser pour les appels vers l'API
   */
  public proc_getHeaders(): any {
    let httpOptions;

    this.h_currentUser = JSON.parse(localStorage.getItem("currentUser"));
    if (!this.h_currentUser) {
      httpOptions = {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Accept: "application/json"
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + this.h_currentUser.token
        })
      };
    }

    return httpOptions;
  }

  /**
   * Méthode d'affichage d'erreur sur les appels API
   */
  public proc_gestionErreur(error: any) {
    if (error == null) {
      this.s_toaster.proc_toastTradError("Messages.erreur_std");
      return;
    }

    if (error.status === 0)
      this.s_toaster.proc_toastTradError("Messages.erreur_pasServeur");
    else if (error._body != null && error._body !== "")
      this.s_toaster.proc_toastTradError(error._body);
    else this.s_toaster.proc_toastTradError("Messages.erreur_std");
  }

  /**
   * Fonction de recuperation d'une traduction grace a un code de traduction
   * Parametres : Code de traduction du message a afficher
   * Retour : String a afficher
   */
  public proc_getTraduction(codeTraduction: string) {
    /** Message pour l'affichage dans les toasters */
    let w_msg: string;
    this.s_translate.get(codeTraduction).subscribe(message => {
      w_msg = message;
    });
    return w_msg;
  }

  /**
   * Fonction de formattage de la date en UTC afin de supprimer l'offset lié au fuseau horaire
   * Parametres : String de la date recu en JSON
   * Retour : Date UTC
   */
  public proc_formatDate(dateToFormat: any) {
    if (dateToFormat == null) return null;

    dateToFormat = new Date(
      new Date(dateToFormat.substring(0, 19)).getTime() -
        new Date(dateToFormat.substring(0, 19)).getTimezoneOffset() * 60000
    );
    return dateToFormat;
  }

  /**
   * Passe l'heure d'une date à midi. Pb fuseau horaire
   */
  public proc_formatDateMidi(d_date: Date): Date {
    if (d_date == null) return null;

    d_date.setHours(12);
    d_date.setMinutes(0);
    d_date.setSeconds(0);
    d_date.setMilliseconds(0);
    return d_date;
  }
}



// WEBPACK FOOTER //
// C:/spro/Workspaces/VisualCode/Ecoltex2/src/app/services/appsettings.service.ts